<script>
  import { landingsside } from '../../stores/landingsside'
  import Lenker from '../lenke/lenker.svelte'
  import Topplenker from './topplenker.svelte'
</script>

<Topplenker />
<Lenker lenker={$landingsside.lenker} trackingId="lenker-forside" />
